<div
    class="flex items-center gap-3 rounded-xl border px-5 py-4"
    [ngClass]="{
        'border-primary-200 bg-primary-50': mode === 'default',
        'border-emerald-200 bg-emerald-50': mode === 'success',
        'border-blue-200 bg-blue-50': mode === 'info',
        'border-amber-200 bg-amber-50': mode === 'warning',
        'border-rose-200 bg-rose-50': mode === 'danger',
    }"
    role="alert"
>
    <!-- Icon -->
    <div
        class="flex h-10 w-10 shrink-0 items-center justify-center rounded-full"
        [ngClass]="{
            'bg-primary-100': mode === 'default',
            'bg-emerald-100': mode === 'success',
            'bg-blue-100': mode === 'info',
            'bg-amber-100': mode === 'warning',
            'bg-rose-100': mode === 'danger',
        }"
    >
        <i
            class="fa-light text-lg"
            [ngClass]="{
                'fa-lightbulb text-primary-600': mode === 'default',
                'fa-circle-check text-emerald-600': mode === 'success',
                'fa-circle-info text-blue-600': mode === 'info',
                'fa-triangle-exclamation text-amber-600': mode === 'warning',
                'fa-circle-xmark text-rose-600': mode === 'danger',
            }"
        ></i>
    </div>

    <!-- Content -->
    <div class="flex-1">
        <p
            class="font-medium"
            [ngClass]="{
                'text-primary-800': mode === 'default',
                'text-emerald-800': mode === 'success',
                'text-blue-800': mode === 'info',
                'text-amber-800': mode === 'warning',
                'text-rose-800': mode === 'danger',
            }"
        >
            {{ label | translate }}
        </p>
        @if (description) {
            <p
                class="mt-0.5 text-sm"
                [ngClass]="{
                    'text-primary-700': mode === 'default',
                    'text-emerald-700': mode === 'success',
                    'text-blue-700': mode === 'info',
                    'text-amber-700': mode === 'warning',
                    'text-rose-700': mode === 'danger',
                }"
            >
                {{ description | translate }}
            </p>
        }
    </div>

    <!-- Tools -->
    <div class="flex items-center gap-2">
        <ng-content select="[tools]"></ng-content>
    </div>
</div>
